import * as React from 'react';
import { useDialog } from './useDialog';

export type DialogContextValues = ReturnType<typeof useDialog> | null;

export const DialogContext = React.createContext<DialogContextValues>(null);

export function useDialogContext() {
    const context = React.useContext(DialogContext);
    if (context == null) {
        throw new Error('Dialog child components must be wrapped in <Dialog />');
    }
    return context;
}
